<ng-container *ngIf='!isLoading, else showLoading'>
  <div class="row mb--md">
    <div class='column--12 align-right'>
      <button mat-raised-button color="primary" (click)='openHotspotDrawer()' [disabled]='!canEdit'>
        Create Hotspot
      </button>
    </div>
  </div>

  <mat-card>
    <mat-card-content>
      <ng-container *ngIf="hotspots?.length > 0, else noHotspots">
        <div class='responsive-table'>
          <table mat-table [dataSource]="hotspots" class='mat-elevation-z0'>
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef style='width: 30%'>Name</th>
              <td mat-cell *matCellDef="let hotspot">{{ hotspot.name }}</td>
            </ng-container>

            <!-- Page Column -->
            <ng-container matColumnDef="page">
              <th mat-header-cell *matHeaderCellDef>Page</th>
              <td mat-cell *matCellDef="let hotspot">{{ hotspot.pageSlug || 'N/A' }}</td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style='width: 100px'>Status</th>
              <td mat-cell *matCellDef="let hotspot">
                <mat-chip
                  class='chip-status'
                  [ngClass]="hotspot.isActive ? 'active' : 'inactive'"
                  (click)='toggleHotspot(hotspot)'
                  [disabled]='!canEdit'
                >
                  {{ hotspot.isActive ? 'Active' : 'Inactive' }}
                </mat-chip>
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style='width: 150px'></th>
              <td mat-cell *matCellDef="let hotspot">
                <button mat-icon-button color="primary" (click)='editHotspot(hotspot)' [disabled]='!canEdit'>
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="deleteHotspot(hotspot)" [disabled]='!canEdit'>
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
          </table>
        </div>
      </ng-container>
      <ng-template #noHotspots>
        <div class='row justify-content-center mt--lg'>
          <div class='column--12 column-md--4 align-center'>
            <img src='{{ CDN_URL }}/admin/images/empty_animated.svg' width='250' />
            <p>No hotspots found.</p>
          </div>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</ng-container>
<ng-template #showLoading>
  <div class='align-center mt--lg'>
    <app-loading></app-loading>
  </div>
</ng-template>
